import React from 'react';
import { Shield, Users, Map, Calendar, Globe } from 'lucide-react';
export function TrustBar() {
  const items = [{
    icon: Users,
    text: 'Adult group travel specialists'
  }, {
    icon: Shield,
    text: 'Dedicated organizer support'
  }, {
    icon: Map,
    text: 'Curated guided itineraries'
  }, {
    icon: Calendar,
    text: 'Clear planning + payment timeline'
  }, {
    icon: Globe,
    text: 'Worldwide destinations'
  }];
  return <section className="bg-primary text-white py-10 border-b border-primary-dark" data-id="element-255">
      <div className="container mx-auto px-4" data-id="element-256">
        <div className="flex flex-wrap justify-center gap-6 md:gap-10" data-id="element-257">
          {items.map((item, index) => <div key={index} className="flex items-center space-x-3 bg-primary-dark/30 px-4 py-2 rounded-full border border-white/10" data-id="element-258">
              <item.icon className="w-5 h-5 text-gold" data-id="element-259" />
              <span className="text-sm md:text-base font-medium" data-id="element-260">
                {item.text}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}